// Copyright (c) 2023, Epiphyte LLC
// All rights reserved.
// Author: Fernandez-Alcon, Jose <jose@epiphyte.io>

import {Avatar, Box, Icon, Menu, MenuButton, MenuItemOption, MenuList} from "@chakra-ui/react";
import * as React from "react";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../Hooks/useAuth";


export const AvatarMenu = () => {
  const navigate = useNavigate();

  const {oikosUser, signOut, isEducator} = useAuth();

  console.log(oikosUser)

  return (
    <Box cursor={"pointer"}>
      <Menu>
        <MenuList minWidth='240px'>
          <MenuItemOption onClick={() => {navigate("/profile")}}  value='asc'>Profile</MenuItemOption>
          <MenuItemOption onClick={() => {navigate("/settings")}}  value='asc'>Settings</MenuItemOption>
          {/*{ !isEducator() &&*/}
          {/*  <MenuItemOption onClick={() => {navigate("/search")}}  value='asc'>Search</MenuItemOption>*/}
          {/*}*/}
          {/*{ isEducator() &&*/}
          {/*  <MenuItemOption onClick={() => {navigate("/schedule")}}  value='asc'>Schedule</MenuItemOption>*/}
          {/*}*/}
          <MenuItemOption
            onClick={signOut}
            value='asc'>
            Logout
          </MenuItemOption>
        </MenuList>
        <MenuButton
          as={Avatar}
          colorScheme='brand'
          name={oikosUser.Name + " " + oikosUser.FamilyName}
          src={`data:image;base64,${oikosUser.Avatar}`}
        >
        </MenuButton>
      </Menu>
    </Box>
  )
}
